<template>
  <div class="twelve columns">
    <el-autocomplete
      :ref="findautocomplete"
      v-model="value"
      class="twelve columns"
      :fetch-suggestions="search"
      :placeholder="placeHolder"
      :trigger-on-focus="false"
      :debounce="500"
      :disabled="disabled"
      @select="select"
      @blur="blur"
    >
      <template #suffix>
        <i
          v-if="!disabled"
          style="cursor: pointer;"
          @click="clear"
        >
          <font-awesome-icon icon="circle-xmark" />
        </i>
      </template>
      <template #default="props">
        <div class="value">
          {{ formatPopup(props.item) }}
        </div>
      </template>
    </el-autocomplete>
  </div>
</template>

<script>
import { buildURLPath } from 'apsis-util';
import isArray from 'lodash/isArray';
import { mapActions } from 'pinia';
import { mainStore } from 'operass-spa/src/store/index';

export default {
  props: {
    requestDelay: {
      type: Number,
      default: 500,
    },
    minChars: {
      type: Number,
      default: 2,
    },
    url: {
      type: String,
      required: true,
    },
    formatResult: {
      type: Function,
      required: true,
    },
    formatPopup: {
      type: Function,
      required: true,
    },
    placeHolder: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    queryParam: {
      type: String,
      default: '',
      required: false,
    },
    autoSelect: {
      type: Boolean,
      default: false,
      required: false,
    },
    queryParamValid: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  emits: ['onSelected', 'onClear'],
  data() {
    return {
      minchars: this.minChars,
      requestdelay: this.requestDelay,
      results: [],
      value: this.formatPopup(this.item),
      // url: this.url,
      tmpResult: {}, // armazena o resultado anterior
    };
  },
  computed: {
    findautocomplete() { return 'find'; },
  },
  watch: {
    item: 'updateItem',
  },
  methods: {
    ...mapActions(mainStore, ['setServiceLoading']),
    updateItem() {
      if (this.item !== null && (this.item.id !== null
      || this.item.codigo !== null)) {
        this.value = this.formatPopup(this.item);
        this.select(this.item);
      } else {
        this.value = '';
      }
    },
    search(query, cb) {
      if (query === '' || query.length < this.minchars || !this.queryParamValid) {
        this.results = [];
        cb(this.results);
        return;
      }
      this.setServiceLoading(false);
      setTimeout(() => {
        this.$http.get(`${this.url}/${buildURLPath([query])}?${this.queryParam}`)
          .then((response) => {
            this.results = isArray(response.data) ? response.data : [];
            if (this.autoSelect && isArray(response.data) && response.data.length === 1) {
              this.select(response.data[0]);
              cb([]);
            } else {
              cb(this.results);
            }
          }).catch((error) => {
            console.error(error);
          });
      }, this.requestdelay);
    },
    select(current) {
      this.tmpResult = current;
      this.value = this.formatResult(this.tmpResult);
      this.$emit('onSelected', current);
    },
    clear() {
      this.tmpResult = {};
      this.value = '';
      this.results = {};
      this.$emit('onClear');
    },
    blur() {
      this.value = this.formatResult(this.tmpResult);
    },
    forceRefreshValue(item) {
      const t = this.formatResult(item);
      this.value = t;
    },
  },
};
</script>

<style scoped>
  .find-container {
     width: 500px;
  }
</style>
